import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { MasterService } from 'app/services/master/master.service';
import { MstInjuryTimeModel } from 'app/model/mst.injuryTime.model';
import { DropdownBaseComponent } from 'app/components/dropdown/dropdown-base.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';


@Component({
    selector: 'dropdown-injuryTime',
    templateUrl: './dropdown-base.component.html',
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DropdownInjuryTimeComponent),
        multi: true
    }]
})
export class DropdownInjuryTimeComponent extends DropdownBaseComponent implements OnInit {

    constructor(private masterService: MasterService) {
        super();
    }

    async ngOnInit() {
        this.list = await this.masterService.getInjuryTimes();
    }
}


// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/components/dropdown/dropdown-injuryTime.component.ts